import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import UsuariosPermisosScreen from './screen';
import { UsuariosAdapter, UsuarioPermisos } from '../../../../../infraestructure/persistence/rest/UsuariosAdapter';
import { useNotifications } from '../../../../../shared/hooks/Notifications';

const UsuariosPermisosContainer = () => {

	const api = new UsuariosAdapter();
	const {resultError, exceptionError, launchNotification}  = useNotifications();
	let [ usuarios, setUsuarios ] = useState<any>([]);
	let result: any;

	useEffect(() => {
		getUsuarios();
	}, []);

	const getUsuarios = async () => {
		try {
			result = await api.ListarUsuariosListado();
			if(result.data && result.data!=="")
			{
				//setUsuarios([ ...result.data.filter((f:any)=> f.perfil!=='USR' && f.perfil!=='RRH' && f.perfil!=='ADM') ] || []);
				setUsuarios([ ...result.data.filter((f:any)=> f.perfil!=='RRH' && f.perfil!=='ADM').filter((f:any)=> (f.administraUsuarios===true || f.controlUsuarios===true) || (f.perfil==='RAR')) ] || []);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

	const getPermissionsUser = async (user:any,fnCallBack:any) => {
		try {
			result = await api.GetPermisosUsuario(user.dni);
			if(result.data && result.data!=="")
			{
				const newData = {...user,...{permisos:result.data}}
				fnCallBack(newData);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

	const AplicarPermisosUser = async (dataUser:any) => {
		try {
			result = await api.AplicarPermisosUsuario(dataUser.user.dni,dataUser.idDNSel,dataUser.permisos);
			if(result.data && result.data!=="")
			{
				getUsuarios();
				launchNotification({type:"success",title:"Creación",message:`Se han creado nuevos permisos para el usuario ${dataUser.user.nombre}`})
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

	return (
		<>
		<UsuariosPermisosScreen
			users={usuarios}
			handleGetPermissionsUser={getPermissionsUser}
			handleCreatePermissionsUser={AplicarPermisosUser}
			launchNotification = {launchNotification}
		/>
		</>
	);
};

export default UsuariosPermisosContainer;
